package ai.beakman.undercover.online

import kotlin.time.Clock
import kotlin.time.ExperimentalTime

/** Tempo atual em epoch millis (wall clock), multiplataforma — usa o Clock do stdlib (kotlin.time). */
@OptIn(ExperimentalTime::class)
fun nowMillis(): Long = Clock.System.now().toEpochMilliseconds()
